import { baseClassName, sizeClassName, variationClassName } from '@/components/pages/cta';
import { ChevronDown } from '@/components/pages/icons';
import type { AnimatedFormWrapperProps } from './type';

export function AnimatedFormWrapper({
  ref,
  children,
  hideButton,
  onChange,
}: AnimatedFormWrapperProps) {
  return (
    <div ref={ref} className="relative mb-8 px-8 group/wrapper">
      <input type="checkbox" id="form-expand" className="peer sr-only" onChange={onChange} />

      <div className="relative overflow-hidden rounded-2xl pt-3 max-h-75 peer-checked:max-h-500 transition-[max-height] duration-700 ease-in-out">
        <div className="relative rounded-2xl backdrop-blur-xl border border-white/20 p-4">
          <div className="z-1 relative">{children}</div>
          <div className="absolute inset-0 bg-black/30 z-0 rounded-2xl "></div>
          <div className="absolute inset-0 bg-linear-to-br from-blue-600 to-sky-500 opacity-30 z-0 rounded-2xl"></div>
        </div>
        <label
          htmlFor="form-expand"
          className="group-has-checked/wrapper:pointer-events-none group-has-checked/wrapper:hidden w-full h-full top-0 left-0 absolute"
        />
      </div>

      <label
        htmlFor="form-expand"
        className="absolute bottom-0 left-8 right-8 rounded-b-2xl flex justify-center p-4 bg-linear-to-b from-transparent to-[#7ba3c8] cursor-pointer transition-opacity duration-300 peer-checked:opacity-0 peer-checked:pointer-events-none"
      >
        {!hideButton && (
          <span className={`${baseClassName} ${variationClassName.shadow} ${sizeClassName.lg}`}>
            Start free review
          </span>
        )}
      </label>

      <label
        htmlFor="form-expand"
        className="absolute top-8 right-12 peer-checked:opacity-100 opacity-0 transition-opacity duration-700 ease-in-out peer-checked:cursor-pointer peer-checked:hover:brightness-90"
      >
        <ChevronDown className="h-6 w-6 text-white" />
      </label>
    </div>
  );
}
